import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import Loading from "../UI/Loading";

/** Lista das disciplinas da instituição. */
export default function DisciplinaTable({ disciplinas, isLoading, emptyText, onEdit, onDelete }) {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando disciplinas..." />
      </Box>
    );
  }

  if (disciplinas.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <MenuBookOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          {emptyText}
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Disciplinas">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Descrição</TableCell>
            <TableCell align="right" sx={{ width: 96 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {disciplinas.map((disciplina) => (
            <TableRow key={disciplina.codDisciplina} hover>
              <TableCell>{disciplina.descricao}</TableCell>
              <TableCell align="right">
                <Tooltip title="Editar">
                  <IconButton size="small" onClick={() => onEdit(disciplina)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                  <IconButton size="small" onClick={() => onDelete(disciplina)}>
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
